import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { PharmaDataService } from "../pharma-data.service";
import { FilterEventChanged } from "src/app/store/actions/pharma-page.actions";
import { GridSettings } from "src/app/store/models/pharma-page-store.model";
import { Subscription } from "rxjs";

@Component({
  selector: "app-database-grid-container",
  templateUrl: "./database-grid-container.component.html",
  styleUrls: ["./database-grid-container.component.scss"],
})
export class DatabaseGridContainerComponent implements OnInit, OnDestroy {
  gridSettings: GridSettings;
  facetFilters;
  chartFilters;
  fullExport: boolean;
  totalCount: number;
  consolidatedTotal: number;
  columnList = [];
  periodObj;
  selectedCurrency: string;
  indicationBreakout = false;
  showNIB = false;
  disableNIBControl: boolean = false;
  indicationBreakoutContol = false;
  pharmaDatabasePageSubscriber: Subscription;
  constructor(
    private store: Store<AppState>,
    private service: PharmaDataService,
  ) {}

  ngOnInit() {
    this.periodObj = {};

    this.selectedCurrency = "USD";

    this.columnList = [];
    this.pharmaDatabasePageSubscriber = this.store
      .select(stateGetter("pharmaDatabasePage"))
      .subscribe((data: any) => {
        this.chartFilters = data.chartFilters;
        this.facetFilters = data.facetFilters;
        if (
          data.filterEvent.filterChanged &&
          data.filterEvent.filterChanged !== "grid" &&
          data.filterEvent.source !== ""
        ) {
          if (this.gridSettings && this.gridSettings.options)
            this.updateGridSettings();
          this.service.logUserAction("UPDATE_GRID", {
            source: data.filterEvent.source,
            filter: data.filterEvent.filterChanged,
            gridSettings: this.gridSettings,
          });
        }
      });
  }
  onFacetChange(facetFilter) {
    this.gridSettings.options.filter = facetFilter;
    this.gridSettings = { ...this.gridSettings };
    this.service.globalGridSettings.next(this.gridSettings);
  }
  setDefaultGridSettings(data) {
    this.selectedCurrency = data.currency;
    this.columnList = data.columnList;
    this.periodObj = data.period;
    const facetFilter = { ...this.facetFilters };
    this.gridSettings = {
      options: {
        filter: facetFilter,
        data: {
          currency: this.selectedCurrency,
          periodData: this.periodObj,
          viewBy: "values",
          revision: "",
          revenue_type: "total_revenue",
        },
      },
      indicationBreakout: false,
      showNIB: false,
      columnList: this.columnList,
    };

    this.service.globalGridSettings.next(this.gridSettings);
    this.disableNIBControl =
      this.facetFilters.indication.length === 0 ||
      (this.facetFilters.indication.length > 0 &&
        this.facetFilters.geo.length > 0);
    this.indicationBreakoutContol = this.facetFilters.indication.length > 0;
    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "grid",
        source: "default",
      }),
    );
  }
  updateGridSettings() {
    this.gridSettings.options.filter = this.service.superimposeChartFilters(
      this.chartFilters,
      this.facetFilters,
    );
    this.indicationBreakout = false;
    this.showNIB =
      this.gridSettings.options.filter.indication.length > 0
        ? this.gridSettings.showNIB
        : false;
    this.disableNIBControl =
      this.facetFilters.indication.length === 0 ||
      (this.facetFilters.indication.length > 0 &&
        this.facetFilters.geo.length > 0);
    this.indicationBreakoutContol = this.facetFilters.indication.length > 0;
    this.gridSettings = { ...this.gridSettings };
    this.service.globalGridSettings.next(this.gridSettings);
  }
  updateColumnList(list) {
    this.columnList = [...list];
    this.gridSettings.columnList = [...this.columnList];
    this.gridSettings = { ...this.gridSettings };
    this.service.globalGridSettings.next(this.gridSettings);
  }

  updatePeriodSettings(periodObj) {
    this.gridSettings.options.data.periodData = { ...periodObj };
    this.gridSettings = { ...this.gridSettings };
    this.service.globalGridSettings.next(this.gridSettings);
    this.service.logUserAction("UPDATE_GRID", {
      source: "grid",
      filter: "period",
      gridSettings: this.gridSettings,
    });
  }
  updateDataSettings(dataSettings) {
    this.gridSettings.options.data = {
      ...this.gridSettings.options.data,
      ...dataSettings,
    };
    this.indicationBreakout = false;
    // this.showNIB = false;
    // this.disableNIBControl = !(this.facetFilters.indication.length > 0);
    this.indicationBreakoutContol = this.facetFilters.indication.length > 0;
    this.gridSettings = { ...this.gridSettings };
    this.service.globalGridSettings.next(this.gridSettings);
    const keys = Object.keys(dataSettings);
    let filter = keys[0];
    if (keys.length > 1) {
      filter = "data-revision";
    }
    this.service.logUserAction("UPDATE_GRID", {
      source: "grid",
      filter: filter,
      gridSettings: this.gridSettings,
    });
  }
  indicationBreakoutChanged(flag) {
    this.indicationBreakout = flag;
  }
  showNIBChanged(flag) {
    this.showNIB = flag;
  }
  ngOnDestroy(): void {
    if (this.pharmaDatabasePageSubscriber) {
      this.pharmaDatabasePageSubscriber.unsubscribe();
    }
  }

  onFullExportFlagChange(fullExport) {
    this.fullExport = fullExport;
  }

  onTotalCountChange(count) {
    this.totalCount = count;
  }

  onConsolidatedCountChanged(count) {
    this.consolidatedTotal = count;
  }
}
